import { getStoreStatus } from './storeStatus';

export const STORE_DISCOVERY_ALL_SPECIALTIES = 'Todas';

export const buildNearbySearchBody = (
  location: Record<string, any>,
  specialty: string
) => {
  const normalizedSpecialty = specialty.trim();
  if (!normalizedSpecialty || normalizedSpecialty === STORE_DISCOVERY_ALL_SPECIALTIES) {
    return { ...location };
  }
  return { ...location, especialidade: normalizedSpecialty };
};

export type NearbyStore = {
  id: string;
  nome: string;
  urlLogo?: string;
  especialidades: string[];
  distanciaMetros: number | null;
  distanciaKm: number | null;
  taxaEntrega: string | number;
  tempoEntrega: string | number;
  horarios: any[];
  deliveryFechado: boolean;
  bloquearAcesso: boolean;
};

const normalizeText = (value: string) => value
  .normalize('NFD')
  .replace(/[\u0300-\u036f]/g, '')
  .toLowerCase()
  .trim();

export const filterStoresBySpecialty = (
  stores: NearbyStore[],
  specialty: string
) => {
  const normalizedSpecialty = normalizeText(specialty);
  if (!normalizedSpecialty || specialty === STORE_DISCOVERY_ALL_SPECIALTIES) return stores;

  return stores.filter((store) => (store.especialidades || [])
    .some((storeSpecialty) => normalizeText(storeSpecialty) === normalizedSpecialty));
};

export const filterAndSortStores = (
  stores: NearbyStore[],
  search: string,
  now = new Date()
) => {
  const normalizedSearch = normalizeText(search);

  return stores
    .filter((store) => {
      const storeSpecialties = store.especialidades || [];
      const searchableText = normalizeText(`${store.nome} ${storeSpecialties.join(' ')}`);
      return !normalizedSearch || searchableText.includes(normalizedSearch);
    })
    .sort((first, second) => {
      const firstStatus = getStoreStatus(first, now);
      const secondStatus = getStoreStatus(second, now);
      if (firstStatus.isOpen !== secondStatus.isOpen) return firstStatus.isOpen ? -1 : 1;
      return (first.distanciaMetros ?? Number.MAX_SAFE_INTEGER)
        - (second.distanciaMetros ?? Number.MAX_SAFE_INTEGER);
    });
};
